module.exports = __webpack_public_path__ + "media/brand/Perfil-auto-huincha-santander-b24cedf7.png";